<template>
  <div class="job-page f-c">
    <job-page-stats :jobType="queryJobType" />
    <div class="job-list" v-loading="loadingJobs">
      <el-tabs v-model="queryJobType" @tab-click="selectTabChange">
        <el-tab-pane
          v-for="(tab, index) in Tabs"
          :key="'job-tab-' + index"
          :label="tab"
          :name="tab"
        />
      </el-tabs>
      <searchable-table
        :table-headers="tableHeaders"
        :table-data="jobPage"
        :search-params="searchForm"
        :search-param-change="searchParamChange"
        :has-actions="true"
      >
        <template v-slot:actions="props">
          <el-button
            size="small"
            type="text"
            @click="() => goToJobDetail(props.row.no)"
          >
            Detail
          </el-button>
        </template>
      </searchable-table>
    </div>
  </div>
</template>
<script>
// others
import set from 'lodash/set'
// apis
import { queryJobs } from '@/api/job'
// mixin
import { pageJumps } from '@/core/mixin/pages'
// models
import {
  JobSearchForm,
  JobTableHeaders,
  UnloadingJobTableHeaders,
  JobSearchParamsWrapUp,
  UnloadingJobSearchForm
} from '@/core/models/job'
import { InboundJob, JobTypes, UnloadingJob } from '@/core/models/constant'
// components
import JobPageStats from '@/components/jobs/JobPageStats.vue'
import SearchableTable from '@/components/common/SearchableTable.vue'
import { InitSearchForm } from '@/core/configs/types'
export default {
  name: 'JobPage',
  mixins: [pageJumps],
  components: {
    JobPageStats,
    SearchableTable
  },
  data() {
    return {
      JobTableHeaders,
      JobSearchForm,
      JobTypes,
      jobPage: null,
      loadingJobs: false,
      searchForm: {}
    }
  },
  watch: {
    queryJobType: {
      handler: function () {
        switch (this.queryJobType) {
          case UnloadingJob:
          case InboundJob:
            this.$set(
              this,
              'searchForm',
              InitSearchForm(UnloadingJobSearchForm, UnloadingJobTableHeaders)
            )
            break
          default:
            this.$set(
              this,
              'searchForm',
              InitSearchForm(JobSearchForm, JobTableHeaders)
            )
        }
        if (Object.values(JobTypes).includes(this.queryJobType)) {
          this.doJobSearch(this.searchForm)
        } else {
          this.searchJob({ jobType: UnloadingJob }, true)
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    tableHeaders() {
      switch (this.queryJobType) {
        case UnloadingJob:
        case InboundJob:
          return UnloadingJobTableHeaders
        default:
          return JobTableHeaders
      }
    },
    queryJobType: {
      get() {
        return this.$route.query?.jobType
      },
      set(value) {
        this.searchJob({ jobType: value })
      }
    },
    Tabs() {
      return Object.values(JobTypes)
    }
  },
  mounted() {},
  methods: {
    // -------------------- apis ---------------------
    async doJobSearch() {
      this.loadingJobs = true
      const jobSearchForm = JobSearchParamsWrapUp(this.searchForm)
      jobSearchForm.types = [this.queryJobType]
      const page = await queryJobs(jobSearchForm)
      this.loadingJobs = false
      this.$set(this, 'jobPage', page)
    },
    // -------------------- button functions ---------------------
    selectTabChange() {
      this.goToSearchJob({ jobType: this.queryJobType })
    },
    createPalletJob(jobType) {
      this.goToCreateJob({ jobType })
    },
    searchParamChange(key, path, value) {
      set(this.searchForm[key], path, value)
      this.doJobSearch()
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.job-page {
  gap: 20px;

  @extend .global-margin;

  .job-list {
    @extend .shadow-level-three;

    border-radius: $home-card-border-radius;
    padding: $home-card-padding-y $home-card-padding-x;
    background-color: white;
  }

  .functions-board {
    gap: 15px;
  }
}
</style>
